import { render, staticRenderFns } from "./cwddgj.vue?vue&type=template&id=044faa06&scoped=true&"
import script from "./cwddgj.vue?vue&type=script&lang=js&"
export * from "./cwddgj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044faa06",
  null
  
)

export default component.exports